<template>
<nav class="ff ff-disable-auto ff-align-between ff-valign-center ff-content-center" :class="bgColor">
  <router-link to="/" title="CSBP Soil and Plant Analysis Laboratory" class="home-link ff ff-nowrap ff-valign-center ff-content-center">
    <div class="logo-graphic ff-auto">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 62" v-bind:svg-inline="''" v-bind:title="'CSBP'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="graphic" fill="#FFF" d="M.5.1v7.3h13.7l8.1 8.3v27h2.6v-34L16.3.1H.5zm0 8.2v7.3h10.4l6.8 6.5v20.7h2.6v-27l-7.5-7.5H.5zm0 8.2v6.6h6.7l5.9 5.5v14.2h2.6v-21l-5.6-5.3H.5zm0 7.4v7.2h4.1l3.8 3.7v8H11V28.3l-4.9-4.4H.5zm33.1 30h-2.9v-2h2.9c.3 0 .6.2.6 1s-.3 1-.6 1m0 5h-2.9v-2h2.9c.3 0 .6.2.6 1s-.3 1-.6 1m-7-10V62h9.6l2.3-2.3v-2.8l-1.3-1.3 1.2-1.3v-3L36 48.9h-9.4zM.4 59.7L2.9 62h7.5l2.3-2.3v-2.6h-4v1c0 .7-.5.9-.8.9H5.4c-.7 0-.8-.7-.8-.7v-5.4c0-.7.5-.9.7-.9H8c.5 0 .7.7.7.9v2.6h4v-4.2L10.4 49H2.9L.4 51.5v8.2zm25.1-5.8v-2.7l-2.3-2.3h-7.1l-2.3 2.3v4.2l7.7 2v.8c0 .6-.6.7-.6.7h-2.3c-.7 0-.8-.5-.8-.7V57h-4v2.6l2.3 2.3h7.1l2.3-2.3v-4l-7.7-2v-.8c0-.7.6-.8.8-.8h1.9c.9 0 1 .5 1 .7v1.2h4zm21.1 1h-2.7V52h2.8c.4 0 1-.2 1 1.5-.1 1.5-.9 1.4-1.1 1.4m-7-6V62h4.2v-4H49l2.5-2.5v-4.2L48.9 49l-9.3-.1zM51.7.1H35.9l-8.6 8.6v34h2.6v-27L38 7.4h13.7V.1zM39.4 8.3l-7.5 7.5v27h2.6V22.1l6.8-6.5h10.4V8.3H39.4zm-2.9 13.5v21h2.6V28.6l5.9-5.5h6.7v-6.6h-9.6l-5.6 5.3zm15.2 2.1h-5.6l-4.9 4.4v14.5h2.6v-8l3.8-3.7h4.1v-7.2z"/></svg>
    </div>
    <div class="logo-text ff-auto">Soil and Plant <br>Analysis Laboratory</div>
  </router-link>
  
  <div class="ff-desktop-hide">
    <transition name="menu" :duration="1000">
      <div v-show="menuOpen" id="mobile-menu" :style="'height:' + menuHeight + ';'">
        <ul class="menu ff ff-disable-auto ff-content-top">
          <li class="ff-6">
            <router-link to="/tests" class="ff ff-center" @click.native="closeMenu">
              <icon name="icon-beaker" color="white" />
              <span class="ff-12">Tests</span>
            </router-link>
          </li>
          <li class="ff-6">
            <router-link to="/carbon" class="ff ff-center" @click.native="closeMenu">
              <icon name="icon-carbon-element" color="white" />
              <span class="ff-12">Carbon</span>
            </router-link>
          </li>
          <li class="ff-6">
            <router-link to="/faq/downloads/downloads" class="ff ff-center" @click.native="closeMenu">
              <icon name="icon-bubble" color="white" />
              <span class="ff-12">Forms</span>
            </router-link>
          </li>
          <li class="ff-6">
            <router-link to="/faq" class="ff ff-center" @click.native="closeMenu">
              <icon name="icon-bubble" color="white" />
              <span class="ff-12">FAQ</span>
            </router-link>
          </li>
          <li class="ff-6">
            <router-link to="/our-lab" class="ff ff-center" @click.native="closeMenu">
              <icon name="icon-people" color="white" />
              <span class="ff-12">Our Lab</span>
            </router-link>
          </li>
          <li class="ff-6">
            <router-link to="/contact" class="ff ff-center" @click.native="closeMenu">
              <icon name="icon-mail" color="white" />
              <span class="ff-12">Contact Us</span>
            </router-link>
          </li>
          <li class="ff-12">
            <a href="tel:0894344600" class="ff ff-center">
              <icon name="icon-phone" color="white" />
              <span class="ff-12">08 9434 4600</span>
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
  
  <div class="ff-mobile-hide">
    <div id="desktop-menu">
      <ul class="menu ff ff-center ff-nowrap">
        <li>
          <router-link to="/tests">
            Tests
          </router-link>
        </li>
        <li>
          <router-link to="/carbon">
            Carbon
          </router-link>
        </li>
        <li>
          <router-link to="/faq/downloads/downloads">
            Forms
          </router-link>
        </li>
        <li>
          <router-link to="/faq">
            FAQ
          </router-link>
        </li>
        <li>
          <router-link to="/our-lab">
            Our Lab
          </router-link>
        </li>
        <li>
          <router-link to="/contact">
            Contact
          </router-link>
        </li>
        <li class="phone-link ff-lg-hide">
          <div class="ff ff-center ff-nowrap">
            <icon name="icon-phone" animated=true :color="iconColor" />
            <span>08 9434 4600</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  
  <div class="menu-toggle ff-desktop-hide" v-bind:class="{ 'open': menuOpen }" v-on:click="toggleMenuState">
    <div class="lines">
      <div class="line"></div>
    </div>
  </div>
</nav>
</template>

<script>
  export default {
    name: "Menu",
    data() {
      return {
        
      }
    },
    computed: {
      bgColor () {
        var bannerColor = this.$store.state.menuColor;
        var bgColor = 'bg-black';
        var menuOpen = this.$store.state.menuIsOpen;
        
        if(this.$route.name === "Home" && this.$store.state.scroll.current < this.$store.state.scroll.threshold && !menuOpen) {
          if(bannerColor === 'black') {
            bgColor = 'bg-none menu-'+bannerColor;
          } else {
            bgColor = 'bg-none';
          }
        }
        
        return bgColor;
      },
      iconColor () {
        var bannerColor = this.$store.state.menuColor;
        var iconColor = 'cyan';
        
        if(this.$route.name === "Home" && this.$store.state.scroll.current < this.$store.state.scroll.threshold) {
          iconColor = bannerColor;
        }
        
        return iconColor;
      },
      menuHeight () {
        var menuHeight = window.innerHeight + 'px';
        var screenSize = this.$store.getters.screenSize;
        
        if(screenSize == 'md') {
          menuHeight = window.innerHeight - (window.innerWidth * 0.04) + 'px';
        }
        
        return menuHeight;
      },
      menuOpen () {
        var menuOpen = this.$store.state.menuIsOpen;
        return menuOpen;
      }
    },
    methods: {
      closeMenu() {
        this.$store.commit("toggleMenuState", 'close');
        
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, this.$store.state.scroll.current);
      },
      toggleMenuState () {
        
        // Commit states
        this.$store.commit("forceSetScrollDirection","up");
        this.$store.commit("toggleMenuState");
        
        // Disable scroll
        var menuOpen = this.$store.state.menuIsOpen;
        
        if(menuOpen) {
          document.body.style.position = 'fixed';
          document.body.style.top = '-'+this.$store.state.scroll.current+'px';
        } else {
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, this.$store.state.scroll.current);
        }
        
      }
    }
  }
</script>